export default __webpack_public_path__ + "static/media/Price.34de054f.svg";